import Scrollable from "../../Shared/Edit/Scrollable";
import ComponentToolbar from "./ComponentToolbar/ComponentToolbar";
import componentPropertiesMap from './ComponentFormProperties.json';
import { useChangeBooleans, useComponentProperties, useResetComponentProperties, useSaveComponent } from "../../../Hooks/Display/useComponentProperties";
import { useEffect, useState } from "react";
import { useSelectedComponent } from "../../../Hooks/Display/useComponents";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { useSelectedPage, useUpdatePageComponent } from "../../../Hooks/Display/usePages";
import { usePropsStoreValue } from "../../../Hooks/PropStore/usePropsStore";
import GenericTranslationDialog from "../../Entities/GenericTranslationDialog";
import { isLanguagesChanged } from "../utils";

function History() {

    const formProperties = componentPropertiesMap.History;

    const selectedPage = useSelectedPage();
    const selectedComponent = useSelectedComponent();
    const resetContext = useResetComponentProperties();
    const saveComponent = useSaveComponent();
    const updatePageComponent = useUpdatePageComponent(selectedPage.parentId, selectedPage._id);
    const accessedFromDesigner = usePropsStoreValue("accessedFromDesigner");
    const project = usePropsStoreValue("project");

    const [properties, setProperties] = useComponentProperties();
    const [, setChangeProperty] = useChangeBooleans();

    const [initializationDone, setInitializationDone] = useState(false);
    const [showLabelTranslationDialog, setShowLabelTranslationDialog] = useState(false);

    useEffect(() => {
        for (const property of formProperties) {
            if (
                selectedComponent[property] !== undefined
            ) {
                setProperties(property, selectedComponent[property])
            }
            setChangeProperty("isGeneralPropertiesChanged", false);
        }
        setInitializationDone(true);
    }, [])

    // componentWillUnmount
    useEffect(() => {
        return () => {
            resetContext();
        }
    }, [])

    useEffect(() => {
        debugger
        if (initializationDone) {
            setIsChanged();
        }
    }, [properties, selectedComponent, selectedPage]);

    // state
    const [tabSelected, setTabSelected] = useState(0);

    // functions
    function handleLabel(event) {
        setProperties("label", event.target.value);
    }

    function setLabelTranslation(data) {
        setProperties("languages", data);
        setShowLabelTranslationDialog(false);
    }

    function setIsChanged() {
        let isChanged = false;
        for (const property of formProperties) {
            switch (property) {
                case "languages":
                    if (properties.languages && isLanguagesChanged(properties.languages, selectedComponent.languages)) {
                        isChanged = true;
                    }
                    break;
                default:
                    if (selectedComponent[property] !== properties[property]) {
                        isChanged = true;
                    }
                    break;
            }
            if (isChanged) {
                break;
            }
        }
        setChangeProperty("isGeneralPropertiesChanged", isChanged);
    }

    // handlers
    function handleTabSelect(event) {
        setTabSelected(event.selected);
    }

    async function handleSave() {
        const updatedComponent = await saveComponent();
        debugger;
        updatePageComponent(selectedComponent.id, updatedComponent);
    }

    return (
        <div className={"h-100 d-flex flex-column line" + (!accessedFromDesigner && " runtimePopup")}>
            <ComponentToolbar onSave={handleSave} />
            <Scrollable noPadding={true}>
                <TabStrip className="flex-grow-1 h-100 edit1" selected={tabSelected} onSelect={handleTabSelect}>
                    <TabStripTab title="General">
                        <Scrollable>
                            <form className="p-2 edit2">
                                <div className="form-label" required>
                                    Label
                                </div>
                                <input
                                    placeholder="Enter Label"
                                    className="form-control w-50"
                                    name="Label"
                                    maxLength={256}
                                    onChange={handleLabel}
                                    value={properties.label}
                                    disabled={selectedComponent.hidden}
                                />
                                <div className="col-12">
                                    <div className="form-label d-inline-block cursor-pointer" onClick={() => {
                                        setShowLabelTranslationDialog(true)
                                    }}>
                                        <span className="text-primary">
                                            Label Translation
                                        </span>
                                    </div>
                                </div>
                                {showLabelTranslationDialog && (
                                    <GenericTranslationDialog
                                        onClose={() => { setShowLabelTranslationDialog(false) }}
                                        onSave={setLabelTranslation}
                                        languages={properties.languages}
                                        project={project}
                                        fields={["label"]}
                                    />
                                )}
                            </form>
                        </Scrollable>
                    </TabStripTab>
                </TabStrip>
            </Scrollable>
        </div>
    )
}

export default History;